// extracted by mini-css-extract-plugin
export default {"breakpoint_tablet_max_width_1199":"1199px","scope-fas":"fas_scope-fas","progress_bar_frame":"fas_progress_bar_frame","progress_bar":"fas_progress_bar"};